import MakeTable from "./view/MakeTable";
import { permissionsSelector } from "../../../Login/selectors/permissionSelector";
import { useRecoilValue } from "recoil";
import { PERMISSIONS } from "../../../PermissionsConstants";

const LeasedEquipmentMake = () => {
  const viewPermission =
    PERMISSIONS.permission_utilities_leasedequipment_make_view;
  const userPermissions = useRecoilValue(permissionsSelector);
  return <>{userPermissions.includes(viewPermission) ? <MakeTable /> : ""}</>;
};

export default LeasedEquipmentMake;
